import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Experience = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container experience-page">
        <div className="text-zone" style={{ marginTop: 20 }}>
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['M', 'y', ' ', 'E', 'x', 'p', 'e', 'r', 'i', 'e', 'n', 'c', 'e']}
              idx={15}
            />
          </h1>
          <h2> BaקDeveloper, Appdome, Tel Aviv</h2>
          <h3> January 2023 — June 2024 </h3>
          <p> Technologies used: Node.js, Python, MySQL, AWS, Redis, Docker, Kubernetes, Elasticsearch, GitLab, Jenkins, Microservices, Bash, Kibana</p>
          <p>Proficiently implemented, managed, and enhanced expansive production platforms and features utilizing Node.js best practices, Microservices architecture, Kubernetes orchestration, AWS management, and adept Big Data processing techniques, among other technologies. </p>
          <h2> Backend developer, Enigma securities, Ramat Gan</h2>
          <h3> November 2021 — December 2022 </h3>
          <p> Technologies used: Node.js, Microservices, MySQL, AWS (RDS, EC2, S3, MQ), Redis, RabbitMQ, GitHub, WebSocket, React.</p>
          <p>
            Managed, deployed, and maintained production node.js servers using Backend best practices: API Gateway, Testing, Webhooks, Linter, Project Structure, error handling, among other technologies.
          </p>
          <p style={{ fontSize: '13px', color: 'GrayText' }}>
            For further details regarding my professional background, please feel free to contact me via email at kabariti2@gmail.com, and I will be glad to provide you with my resume
          </p>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Experience
